import React from 'react'
import App from './app'
import store from './store'
import { Provider } from 'react-redux'

const index = props => {
  return (
    <Provider store={store}>
      <App {...props} />
    </Provider>
  )
}

export default index